import HttpRequest from './http-request'
import { getAuthToken } from '../utils/auth.utils'

class CountriesProvider extends HttpRequest {
  getItems (query) {
    this.setHeader(getAuthToken())
    return this.get('/countries', query)
  }

  getItemById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/countries/${id}`)
  }

  create (payload) {
    this.setHeader(getAuthToken())
    return this.post('/countries', payload)
  }

  updateItemById (payload) {
    this.setHeader(getAuthToken())
    return this.patch(`/countries/${payload.id}`, payload)
  }

  deleteItemById (id) {
    this.setHeader(getAuthToken())
    return this.delete(`/countries/${id}`)
  }
}

export default CountriesProvider
